import React from "react";
import { Table } from "../../style";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";

export function ZincOxide(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual PPM?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.zincOxide.pre.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.zincOxide.initial.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento</td>

          <td>
            <Input
              type="inputOnly"
              params="minerals.zincOxide.growth.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Desenvolvimento</td>

          <td>
            <Input
              type="inputOnly"
              params="minerals.zincOxide.development.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
